var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "sale-status" },
    [
      _vm.planOnly
        ? _c("b-badge", { attrs: { variant: "info" } }, [
            _vm._v(_vm._s(_vm.$t("catalog.status.plan_only"))),
          ])
        : [
            _c("b-badge", { attrs: { variant: _vm.meta.variant } }, [
              _vm._v(_vm._s(_vm.$t("catalog.status." + _vm.meta.key))),
            ]),
            _vm.priceLabel
              ? _c("small", { staticClass: "sale-status-price" }, [
                  _vm._v(_vm._s(_vm.priceLabel)),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }